module.exports = __webpack_public_path__ + "img/emoji_87.4da84ed9.png";